const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to get plan list
const getPlanListApi = async (
    token: string, // access token
    planType: number // plan type
): Promise<any> => {

    const url = `${baseURL}/package-list`;

    const data = new FormData();
    data.append("product_type", planType.toString());


    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}


// API to get current package
const getCurrentPackageApi = async (
    token: string, // access token 
    packageID: number, // package Id
    websiteID: number, // website ID
): Promise<any> => {

    const url = `${baseURL}/package-detail`;

    const data = new FormData();
    data.append("id", packageID.toString());
    data.append("website_id", websiteID.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// API to enable or disable add-on
const packageEnableDisableApi = async (
    accessToken: string, // access token
    website_id: number, // website ID
    package_id: number, // add on package Id
    package_status: number // package status
): Promise<any> => {

    const url = `${baseURL}/partner-adon-status-change`;

    const formData = new FormData();

    formData.append("website_id", website_id.toString());
    formData.append("adon_id", package_id.toString());
    formData.append("status", package_status.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: formData
        });

        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { getPlanListApi, getCurrentPackageApi, packageEnableDisableApi }